import { render } from "./wait_building.vue?vue&type=template&id=328d2292"
import script from "./wait_building.vue?vue&type=script&lang=js"
export * from "./wait_building.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__